import type { ReactNode } from 'react';

import { CheckmarkFilled, CloseOutline, Edit } from '@mint-lib/icons';
import { Chip, TruncateText } from '@mint-lib/tw-components';
import type { Suggestions } from '@mint-sdk/api-recommendations';

type Props = {
  logo?: string | null;
  permission?: Suggestions.MediarowPermissionResponseType['permission'];
  label: string;
};

const iconConfig: Record<
  Suggestions.MediarowPermissionResponseType['permission'],
  ReactNode
> = {
  no_access_level: <CloseOutline className="fill-error-active" />,
  read_level: <Edit className="fill-error-active" />,
  read_and_write_level: <CheckmarkFilled className="fill-success-main" />,
};

const PlatformChip = ({ logo = null, label, permission }: Props) => {
  return (
    <Chip
      className="flex max-w-100 flex-row gap-1"
      variant="filled"
      size="medium"
      color="transparent"
    >
      {permission && (
        <div className="flex shrink-0">{iconConfig[permission]}</div>
      )}
      {logo && (
        <img src={logo ?? ''} alt="Platform icon" width="18px" height="18px" />
      )}
      <TruncateText>{label}</TruncateText>
    </Chip>
  );
};

export { PlatformChip };
